import { Box, Container, Grid } from '@material-ui/core';
import { Button } from '@mui/material';
import { SGSCard } from 'components';
import { useAppContext } from 'core/contexts';
import { hasFunctionality, hasRole, isAdmin } from 'core/utils/roles';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import calendar from '../assets/calendar.svg';
import chrono from '../assets/chrono.svg';
import edit from '../assets/edit.svg';
import euro from '../assets/euro.svg';
import finger from '../assets/finger.svg';
import list from '../assets/list.svg';

type MenuCard = {
    id: string,
    link: string,
    img: string,
    title: string,
    content: string,
    roles: string[],
    features?: string[]
};

const ArretTravailHome = () => {
    const history = useHistory();
    const { user } = useAppContext();

    const [menuCards, setMenuCards] = useState<MenuCard[]>([]);

    useEffect(() => {
        const cards = boxes.filter((item) => isAdmin(user) ? hasFunctionality(user, item.features) : hasRole(user, item.roles));
     
        setMenuCards(() => cards);
    },[user]);

    const goToPage = (page: string) => {
        history.push(page);
    };

    return (
        <Container maxWidth="xl">
            <SGSCard>
                <Box sx={styles.container}>
                    <Box sx={styles.titleBox}>Déclarer un arrêt de travail</Box>
                    <Grid container spacing={4}>
                        {menuCards.map((box, index) => (
                            <Grid item xs={12} sm={12} md={12} lg={6} xl={4} key={index} style={{ padding: '15px', paddingTop: '20px' }}>
                                <Box sx={styles.cardBox}>
                                    <Box sx={styles.titleContentBox}>
                                        <img src={box.img} style={{ width: 40, height: 40 }} />
                                        <Box sx={styles.title} dangerouslySetInnerHTML={{ __html: box.title }} />
                                    </Box>
                                    <Box sx={styles.content} dangerouslySetInnerHTML={{ __html: box.content }} />
                                    <Box sx={styles.buttonBox}>
                                        <Button id={box.id} variant="contained" color="primary" sx={styles.btn} onClick={() => goToPage(box.link)}>
                                            Accéder
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </SGSCard>
        </Container>
    );
};

export default ArretTravailHome;

const boxes = [
    {
        id: 'search',
        link: '/arrets/search',
        img: edit,
        title: 'Déclarer<br/> un arrêt INITIAL',
        content: "Seuls les arrêts de travail saisis sur ce formulaire permettront l'utilisation des outils ci-dessous. Le cas échéant, vous devrez transmettre les informations par e-mail à l'adresse : <br/>XXXXX@sgsante.fr",
        roles: ['ROLE_ADD_WORK_STOPPING']
    },
    {
        id: 'prolongation',
        link: 'prolongation',
        img: chrono,
        title: 'Déclarer<br/> UNE PROLONGATION',
        content: 'Non reprise du travail ou avec reprise du travail à temps partiel pour motif thérapeutique.',
        roles: ['ROLE_ADD_WORK_STOPPING']
    },
    { 
        id: 'reprise', 
        link: 'reprise', 
        img: calendar, 
        title: 'Déclarer<br/> une reprise exclusivement', 
        content: 'Reprise à temps complet ou à temps partiel pour raisons personnelles.' ,
        roles: ['ROLE_ADD_WORK_STOPPING']
    },
    {
        id: 'attestation',
        link: 'attestation',
        img: euro,
        title: 'attestation<br/> de salaire',
        content: 'Etablir une attestation de salaire pour indemnisation du temps partiel pour motif thérapeutique.',
        roles: ['ROLE_ADD_WORK_STOPPING']
    },
    {
        id: 'enseignements',
        link: 'enseignements',
        img: list,
        title: 'Déclarer DES enseignements<br/> de salaries de référence',
        content: "Déclarer à SGSanté les renseignements relatifs aux salaries de référence dans le cas d'une franchise atteinte ou d'une erreur de saisie.",
        roles: ['ROLE_ADD_WORK_STOPPING']
    },
    {
        id: 'historique',
        link: '/arrets/history',
        img: finger,
        title: 'Historique /<br/> declaration rectificative',
        content: 'Historique des arrêts de travail / <br/>Effectuer une déclaration rectificative.',
        roles: ['ROLE_ADD_WORK_STOPPING']
    },
    {
        id: 'document_lidl',
        link: '/arrets/documents',
        img: finger,
        title: 'Dépôt de fichier',
        content: 'Déposer un fichier déclaration d\'arrêts de travail au format AG2R.',
        roles: ['ROLE_DOCUMENTS_LIDL'],
        features: ['FEATURE_DOCUMENTS_LIDL']
    }
];

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        alignItems: 'center',
        margin: '0 auto',
        padding: '20px 50px',
        pb: 6,
    },
    titleBox: {
        marginBottom: '1rem',
        fontFamily: 'Segoe UI',
        fontSize: '1.6rem',
        fontWeight: 600,
        lineHeight: '1.5',
        textAlign: 'center',
        color: '#4F7793',
    },

    cardBox: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        height: '100%',

        color: 'white',
        boxShadow: '0px 0px 50px 0px rgba(37, 116, 169, 0.15)',
        borderRadius: '15px 15px ',
        margin: '30px',
    },
    titleContentBox: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',

        marginBottom: '1rem',
        backgroundColor: 'primary.main',
        borderRadius: '15px 15px 0 0',
        padding: '0 20px',
        textTransform: 'uppercase',
        background: '#2574A9',
    },
    title: {
        height: 68,
        fontFamily: 'Segoe UI',
        fontWeight: 700,
        marginLeft: '1rem',
        padding: '10px',
        fontSize: '1rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start'
    },
    content: {
        fontFamily: 'Segoe UI',
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: '1.5',
        textAlign: 'center',
        color: '#4F7793',
        margin: '0',
        height: '100%',
        flexGrow: 1,
        padding: '0 25px ',
        minHeight: '150px',
    },
    buttonBox: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '1rem',
    },
    btn: {
        width: '172px',
        height: '38px',
        borderRadius: '25px',
        background: '#2574A9',
        color: '#FFF',
        textAlign: 'center',
        fontFamily: '"Segoe UI"',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: 'normal',
        textTransform: 'uppercase',
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: '#fff',
            color: '#2574A9',
            border: '1px solid #2574A9',
            boxShadow: 'none',
        },
    },
};
